import React, { useContext, useEffect, useState } from 'react';
import Table from 'react-bootstrap/esm/Table';
import { Store } from '../Store';
import Accordion from 'react-bootstrap/Accordion';
import './sidebar.css';
import { Link } from 'react-router-dom';
import OtpBalanceBadge from './OtpBalanceBadge';
import DbEnvironmentBadge from './DbEnvironmentBadge';

function useNetworkSpeed() {
  const [info, setInfo] = useState({ downlink: 0, uplink: 0, type: '', effectiveType: '' });

  useEffect(() => {
    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const update = () => {
      if (conn) {
        setInfo({
          downlink: conn.downlink || 0,          // Mbps
          uplink: conn.uplink || 0,
          type: conn.type || '',                  // wifi, cellular, ethernet
          effectiveType: conn.effectiveType || '',// 4g, 3g, 2g, slow-2g
        });
      }
    };
    update();
    if (conn) conn.addEventListener('change', update);

    // Also measure real speed every 20s via small fetch
    let active = true;
    const measure = async () => {
      try {
        const start = performance.now();
        const res = await fetch('https://www.google.com/favicon.ico?_=' + Date.now(), { mode: 'no-cors', cache: 'no-store' });
        const elapsed = performance.now() - start;
        // approximate latency-based speed (very rough)
        if (active && conn) update();
      } catch {}
    };
    const iv = setInterval(measure, 20000);

    return () => { active = false; clearInterval(iv); if (conn) conn.removeEventListener('change', update); };
  }, []);

  return info;
}

export default function AdminSideBar() {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const net = useNetworkSpeed();

  const signoutHandler = () => {
    ctxDispatch({ type: 'USER_SIGNOUT' });
    localStorage.removeItem('userInfo');
    localStorage.removeItem('shippingAddress');
    localStorage.removeItem('paymentMethod');
    window.location.reload();
  };

  const speedColor = net.downlink >= 5 ? '#22c55e' : net.downlink >= 1 ? '#f59e0b' : '#ef4444';
  const networkLabel = net.type === 'wifi' ? 'WiFi' : net.type === 'cellular' ? 'Mobile' : net.type === 'ethernet' ? 'LAN' : net.effectiveType || 'Network';

  return (
    <div
      id="adminSideBar"
      style={{
        width: '12%',
        background: '#42b4e7',
        height: '100%',
        float: 'left',
      }}
    >
      <Table>
        <thead>
          <tr>
            <td>
              <a href="/#/admin/dashboard" className="navbar-brand">
                <img
                  src="https://res.cloudinary.com/dddogyqqa/image/upload/v1670435815/logo/clickcart-logo_wfktlg.png"
                  height="30px"
                  alt="ClickCart"
                  style={{ background: 'white', borderRadius: '15px' }}
                />
              </a>
            </td>
          </tr>
          <tr>
            <td style={{ padding: '4px 8px' }}>
              <div style={{
                background: '#0f172a',
                borderRadius: 8,
                padding: '6px 8px',
                textAlign: 'center',
                fontSize: 10,
                color: 'white',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4, marginBottom: 2 }}>
                  <i className="fa fa-wifi" style={{ color: speedColor, fontSize: 11 }} />
                  <span style={{ color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>{networkLabel}</span>
                  <span style={{
                    width: 6, height: 6, borderRadius: '50%',
                    background: speedColor,
                    display: 'inline-block',
                    boxShadow: `0 0 4px ${speedColor}`,
                    animation: 'pulse 2s infinite',
                  }} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                  <div>
                    <i className="fa fa-arrow-down" style={{ color: '#34d399', fontSize: 9, marginRight: 2 }} />
                    <span style={{ color: '#34d399', fontWeight: 'bold' }}>
                      {net.downlink >= 1 ? `${net.downlink} Mb` : `${Math.round(net.downlink * 1024)} Kb`}
                    </span>
                  </div>
                  <div>
                    <i className="fa fa-arrow-up" style={{ color: '#fbbf24', fontSize: 9, marginRight: 2 }} />
                    <span style={{ color: '#fbbf24', fontWeight: 'bold' }}>
                      {net.uplink > 0 ? (net.uplink >= 1 ? `${net.uplink} Mb` : `${Math.round(net.uplink * 1024)} Kb`) : net.effectiveType || '--'}
                    </span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </thead>
      </Table>
      {/* Which database is underneath, before anything else in the sidebar:
          the testing site is identical to the live one and its database is not
          sanitised. */}
      <DbEnvironmentBadge compact />
      <OtpBalanceBadge compact />
      <Accordion style={{ width: '90%', margin: 'auto' }}>
        {/* Owner reports: the business at a glance, first in the list. */}
        <Accordion.Item eventKey="reports">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-bar-chart"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Reports
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/reports">All Reports </Link>
              </li>
              <li>
                <Link to="/admin/reports/sales">Sales &amp; Orders </Link>
              </li>
              <li>
                <Link to="/admin/reports/cashflow">Cash Flow </Link>
              </li>
              <li>
                <Link to="/admin/reports/members">Member Growth </Link>
              </li>
              <li>
                <Link to="/admin/reports/commissions">Commissions &amp; Liability </Link>
              </li>
              <li>
                <Link to="/admin/reports/operations">Staff &amp; Operations </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="0">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-cogs"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Settings
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/config">General </Link>
              </li>
              <li>
                <Link to="/admin/money-controls">Money Controls </Link>
              </li>
              <li>
                <Link to="/admin/messages">Message Center </Link>
              </li>
              <li>
                <Link to="/admin/topup">Topup Requests </Link>
              </li>
              <li>
                <Link to="/admin/topup-settings">Topup Settings </Link>
              </li>
              <li>
                <Link to="/admin/profile-edit-limits">Profile Edit Limits </Link>
              </li>
              <li>
                <Link to="/admin/profile-edit-history">Profile Edit History </Link>
              </li>
              <li>
                <Link to="/admin/designationlist">Commission </Link>
              </li>
              <li>
                <Link to="/admin/globalsales">Global Sales </Link>
              </li>
              <li>
                <Link to="/admin/otp-history">OTP History </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        {/* Developer. Every page here sits behind a single PIN unlock, so these
            are grouped away from the ordinary settings an admin uses daily. */}
        <Accordion.Item eventKey="dev">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-code"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Developer
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/julkarnine">Developer Settings </Link>
              </li>
              <li>
                <Link to="/admin/app-control">App Control </Link>
              </li>
              <li>
                <Link to="/admin/app-releases">App updates </Link>
              </li>
              <li>
                <Link to="/admin/remote-control">Remote Control </Link>
              </li>
              <li>
                <Link to="/admin/broadcast">Send a Message </Link>
              </li>
              <li>
                <Link to="/admin/message-templates">SMS / WhatsApp Templates </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="15">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-bell"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Manage Notices
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/notices">Manage Notices </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="16">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-comments"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Manage Chat
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/chatlist">Manage Chat </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-user"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Manage Users
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/users">Manage Users </Link>
              </li>
              <li>
                <Link to="/admin/addusermanager">Add User Manager </Link>
              </li>
              <li>
                <Link to="/admin/associations">Merchants </Link>
              </li>
              <li>
                <Link to="/admin/association-transfers">Merchant Transfers </Link>
              </li>
              <li>
                <Link to="/admin/money-requests">Money Requests </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-bath"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Promotion History
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/positionhistory">Promotion History </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-user-secret"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Agents
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/agents">Manage Agents </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-bar-chart"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Transactions
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/pointlog">Point Transfer </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="05">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-tachometer"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} History
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/shopping-balance-log">Shopping Balance Log </Link>
              </li>
              <li>
                <Link to="/admin/pointlog">Point Transfer History </Link>
              </li>
              <li>
                <Link to="/admin/withdraw">Withdraw History </Link>
              </li>
              <li>
                <Link to="/admin/availablebalance">Transaction History </Link>
              </li>
              <li>
                <Link to="/admin/global">Global History (Pi) </Link>
              </li>
              <li>
                <Link to="/admin/matching-history">Matching History </Link>
              </li>
              <li>
                <Link to="/admin/income-generation">Income Generation </Link>
              </li>
              <li>
                <Link to="/admin/sales-generation">Sales Generation </Link>
              </li>
              <li>
                <Link to="/admin/convert-history">Convert History </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="06">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-random"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Commission Dist.
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/commissions">Commission Dist. </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="07">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-tasks"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Manage Orders
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/orders">Manage Orders </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="08">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-gift"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Products
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/products">Manage Products </Link>
              </li>
              <li>
                <Link to="/admin/stock">Stock &amp; Stickers </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="12">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-truck"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Delivery
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/delivery">Delivery Counter </Link>
              </li>
              <li>
                <Link to="/admin/stock-log">Stock &amp; Delivery Log </Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="10">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-desktop"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} System Monitor
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/monitor">System Monitor</Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="11">
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-database"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Backup
          </Accordion.Header>
          <Accordion.Body>
            <ul>
              <li>
                <Link to="/admin/backup">Database Backup</Link>
              </li>
            </ul>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="09" onClick={signoutHandler}>
          <Accordion.Header className="sidebar-menu">
            <i
              className="fa fa-sign-out"
              style={{ paddingRight: '10px' }}
              aria-hidden="true"
            ></i>{' '}
            {'  '} Logout
          </Accordion.Header>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}
